// API Configuration for development and production
const envApiUrl = import.meta.env.VITE_API_URL;

// Dynamic API URL detection for cross-device development
const getBaseApiUrl = (): string => {
  if (envApiUrl) {
    // If environment variable is set, use it but adapt for network access
    if (envApiUrl.includes('localhost') && typeof window !== 'undefined') {
      // If we're accessing via network IP, replace localhost with the current host's IP
      const currentHost = window.location.hostname;
      if (currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
        return envApiUrl.replace('localhost', currentHost);
      }
    }
    return envApiUrl;
  }
  
  // Fallback for development
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    const port = '3001';
    return `http://${currentHost}:${port}`;
  }
  
  return 'http://localhost:3001';
};

export const API_BASE_URL = getBaseApiUrl();

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  if (API_BASE_URL) {
    // Production: use full URL to Render backend
    return `${API_BASE_URL}/${cleanEndpoint}`;
  } else {
    // Development: use relative path (Vite proxy will handle it)
    return `/${cleanEndpoint}`;
  }
};

// WebSocket URL
export const getWebSocketUrl = (): string => {
  return API_BASE_URL;
}; 